import './Popup.scss';
import React from 'react';

const Popup = props => {
  const {
    backdrop,
    onClickBackdrop,
    expanded,
    className,
    isPfuPopup,
    storeAddressPfu,
    isPdValuePopUp,
  } = props;
  return (
    <div
      className={`${className || ''} popup-container ${expanded ? 'popup-container-in' : ''} ${
        isPfuPopup ? 'pfu-popup-position' : ''
      } ${storeAddressPfu ? 'store-address-pfu-position' : ''}`}
    >
      <React.Fragment>
        {backdrop && expanded && (
          <div
            className={`backdrop ${expanded ? 'backdrop-in' : ''}`}
            onClick={() => typeof onClickBackdrop === 'function' && onClickBackdrop()}
          ></div>
        )}
        <div
          className={`popup-wrapper bora-4 bg-color_white ${expanded ? 'popup-wrapper-in' : ''} ${
            isPdValuePopUp ? 'isPdValue-del-popup' : ''
          } ${isPfuPopup ? 'pfu-popup-visit-store' : ''} ${
            storeAddressPfu ? 'store-address-pfu' : ''
          }`}
        >
          {props.children}
        </div>
      </React.Fragment>
    </div>
  );
};

export default Popup;
